//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import TableEmployees from './../Employee/TableEmployees.vue'
import DateTimeField from './../../components/Field/DateTimeField.vue'

export default {
  components: {
    TableEmployees,
    DateTimeField
  },
  props: {
    orderAdmittance: {
      type: Object,
      default () {
        return {}
      }
    },
    performer: {
      type: Object,
      required: true
    },
    opened: {
      type: Boolean,
      default: false
    },
    isObservable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      selectedEmployee: null,
      employeeTable: '',
      openedEmployeeTable: false
    }
  },
  watch: {
    'performer.key': function () {
      if (this.performer.key) {
        if (this.orderAdmittance.seniorEmployee && this.performer.key !== this.orderAdmittance.seniorEmployee.key) {
          this.setDefaultInstructorEmployee(this.orderAdmittance.seniorEmployee)
        } else if (this.orderAdmittance.givingEmployee) {
          this.setDefaultInstructorEmployee(this.orderAdmittance.givingEmployee)
        }
      }
    }
  },
  created: function () {
    if (!this.performer.instructageTime) {
      this.performer.instructageTime = this.orderAdmittance.createTime
    }
    if (!this.performer.instructorKey && this.orderAdmittance.seniorEmployee) {
      this.setDefaultInstructorEmployee(this.orderAdmittance.seniorEmployee)
    }
  },
  methods: {
    onShowPerformerEmployeeTable: function () {
      this.employeeTable = 'performerEmployeeTable'
      this.selectedEmployee = this.performer
      this.openedEmployeeTable = true
    },
    savePerformerEmployee: function (employee) {
      this.performer.fio = employee.shortName
      this.performer.key = employee.key
      this.performer.position = employee.positionName
      this.performer.qualifications = employee.performerSkills
      if (this.isObservable) {
        this.performer.organization = 'СПЕЦДОРПРОЕКТ ООО'
      }
      this.closeModal()
    },
    onShowInstructorEmployeeTable: function () {
      this.employeeTable = 'instructorEmployeeTable'
      this.selectedEmployee = {}
      this.selectedEmployee.fio = this.performer.instructorFio
      this.openedEmployeeTable = true
    },
    saveInstructorEmployee: function (employee) {
      this.performer.instructorFio = employee.shortName
      this.performer.instructorKey = employee.key
      this.performer.instructorPosition = employee.positionName
      this.closeModal()
    },
    setDefaultInstructorEmployee: function (employee) {
      this.performer.instructorFio = employee.fio
      this.performer.instructorKey = employee.key
      this.performer.instructorPosition = employee.position
    },
    onClearPerformer: function () {
      this.performer.fio = null
      this.performer.key = null
      this.performer.position = null
      this.performer.qualifications = []
      if (this.isObservable) {
        this.performer.organization = null
      }
    },
    onClearInstructor: function () {
      this.performer.instructorFio = null
      this.performer.instructorKey = null
      this.performer.instructorPosition = null
    },
    closeModal: function () {
      this.openedEmployeeTable = false
      this.selectedEmployee = null
    },
    onSave: function () {
      this.$emit('save', this.performer)
    },
    onClose: function () {
      this.$emit('close')
    }
  }
}

